'use es6';

import { Record } from 'immutable';
import { Networks } from 'AdsUI/lib/Constants';
import KeyMirror from 'react-utils/keyMirror';
const FacebookPagePermissionIssues = KeyMirror({
  USER_NEEDS_ADVERTISE_TASK: null,
  NOT_SAME_BUSINESS_AS_AD_ACCOUNT: null
});
const LinkedInPagePermissionIssues = KeyMirror({
  USER_NEEDS_DSCP_OR_ADMIN_ROLE: null,
  CANNOT_SYNC_LEADS: null
});

class LeadSyncingEntityRecord extends Record({
  id: null,
  name: null,
  adNetwork: null,
  networkUserId: null,
  subscribed: false,
  available: false,
  hasAcceptedTos: false,
  pageAvatarUrl: null,
  differentBusinessManager: false,
  needsAdvertiseTask: false,
  lastSubmissionWithoutEmail: null,
  needsLinkedInRoleToCreateAds: false,
  needsLinkedInRoleToSyncLeads: false,
  isSyncingMarketingContacts: false
}) {
  static getDemoData() {
    return [{
      id: '-1',
      adNetwork: Networks.FACEBOOK,
      available: true,
      leadgenTosAccepted: true,
      subscribed: true,
      name: 'Biglytics',
      networkUserId: null,
      permissionIssues: [],
      isSyncingMarketingContacts: true
    }, {
      id: '-2',
      adNetwork: Networks.FACEBOOK,
      available: true,
      leadgenTosAccepted: true,
      subscribed: true,
      name: 'Biglytics Europe',
      networkUserId: null,
      permissionIssues: [],
      isSyncingMarketingContacts: true
    }, {
      id: '-3',
      adNetwork: Networks.FACEBOOK,
      available: true,
      leadgenTosAccepted: true,
      subscribed: true,
      name: 'Biglytics 日本',
      networkUserId: null,
      permissionIssues: [],
      isSyncingMarketingContacts: true
    }];
  }

  static fromCreationEntity(creationEntity, adNetwork) {
    const {
      id,
      name,
      leadgenTosAccepted,
      isLeadgenTosAccepted,
      pictureUrl,
      permissionIssues,
      subscribed,
      isSyncingMarketingContacts
    } = creationEntity;
    return new LeadSyncingEntityRecord({
      id,
      name,
      adNetwork,
      subscribed,
      isSyncingMarketingContacts,
      pageAvatarUrl: pictureUrl,
      hasAcceptedTos: leadgenTosAccepted || isLeadgenTosAccepted,
      differentBusinessManager: permissionIssues.indexOf(FacebookPagePermissionIssues.NOT_SAME_BUSINESS_AS_AD_ACCOUNT) > -1,
      needsAdvertiseTask: permissionIssues.indexOf(FacebookPagePermissionIssues.USER_NEEDS_ADVERTISE_TASK) > -1,
      needsLinkedInRoleToCreateAds: permissionIssues.indexOf(LinkedInPagePermissionIssues.USER_NEEDS_DSCP_OR_ADMIN_ROLE) > -1,
      needsLinkedInRoleToSyncLeads: permissionIssues.indexOf(LinkedInPagePermissionIssues.CANNOT_SYNC_LEADS) > -1
    });
  }

  static fromSelectedEntity(entity) {
    return new LeadSyncingEntityRecord(entity);
  }

}

export default LeadSyncingEntityRecord;